import styled from 'styled-components';

export const SearchBox = styled.div`
  background: #fff;
  position: absolute;
  top: 58px;
  width: 100%;
  overflow-y: scroll;
  right: 0;
  height: 500px;
  z-index: 99;
  display: none;
  border-radius: 20px;
  box-shadow: 1px 3px 5px 0px #00000036;

  &::-webkit-scrollbar {
    display: none;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #c1c1c1;
  }

  &::-webkit-scrollbar-track {
    background-color: #fff;
  }

  @media (max-width: 720px) {
    right: 0;
    width: 100vw;
    min-height: 280px;
    max-height: 300px;
    top: -1px;
    border-bottom: 2px solid #a09b9b;
    box-shadow: none;
    border-radius: 0px;
  }
`;

export const SearchItem = styled.div`
  display: flex;
  align-items: center;
  padding: 12px 18px;
  font-size: 13px;
  font-weight: 500;
  column-gap: 16px;
  cursor: pointer;
  line-height: 22px;
  .left_portion {
    margin-top: auto;
    margin-bottom: auto;
    span {
      padding-left: 10%;
    }
  }
  .search_text {
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
  & span {
  }

  & img {
    width: clamp(24px, 10vw, 32px);
    height: clamp(24px, 10vw, 32px);
  }

  svg {
    width: 16px;
    height: 16px;
    opacity: 0.6;
  }
  .highlight {
    opacity: 0.4;
  }
  .category_text {
    display: flex;
    flex-direction: column;
    column-gap: 4px;
    .category_class {
      text-transform: capitalize;
      color: #63b0a8;
    }
    .category_field {
      display: flex;
      column-gap: 10px;
      color: #e5e7e7;
    }
  }
`;

export const AutoSearchKeywords = styled.div`
  display: flex;
  align-items: center;
  padding: 12px 18px;
  column-gap: 16px;
  cursor: pointer;

  .search_text {
    opacity: 0.8;
    font-size: 13px;
    line-height: 1;
    text-align: left;
    color: #000;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    width: 100%;
  }
  &.lowOpacity {
    opacity: 0.5;
  }
  .highlight {
    opacity: 0.4;
  }
  svg {
    display: block;
    position: unset;
    width: 16px;
    height: 16px;
  }
  @media (max-width: 720px) {
    cursor: none;
  }
`;
export const SearchIconContainer = styled.div`
  width: 10%;
  height: 10%;
  display: flex;
  justify-content: center;
`;
